import { CloseIcon } from 'assets/icons/CloseIcon'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import { createRoadEvent } from 'features/siteNetwork/siteNetworkSlice'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { BodyText, TitleText } from 'styling/Typography'
import { ICloseRoadModalProps } from 'types/siteNetwork.interface'
import useFocusFirstInput from 'utils/useFocusFirstInput'

export const CloseRoadModal = ({ closeModal, segmentId, segmentName }: ICloseRoadModalProps) => {
  const [reason, setReason] = useState('')
  const dispatch = useDispatch<AppDispatch>()
  useFocusFirstInput()
  useModalClose(closeModal)

  const handleSave = async () => {
    const resp = await dispatch(
      createRoadEvent({ type: 'CLOSED', segmentId, reason: reason.trim() }),
    )
    if (resp.meta.requestStatus === 'fulfilled') {
      closeModal()
    }
  }

  return (
    <Modal black>
      <Flex column gap='1rem' width='100%'>
        <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
          <TitleText weight='bold'>Close road</TitleText>
          <CursorPointer onClick={closeModal}>
            <CloseIcon />
          </CursorPointer>
        </Flex>
        <BodyText grey>{segmentName ?? segmentId}</BodyText>
        <Input
          placeholder='e.g. blasting 12:00–14:00, grader works…'
          labelText='Reason (required)'
          value={reason}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setReason(e.target.value)}
          nomarg
        />
        <Button mt='16' disabled={!reason.trim()} orange onClick={handleSave}>
          Close road
        </Button>
      </Flex>
    </Modal>
  )
}
